import { Component, inject, input, model, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { SheydaBadgeComponent } from '@components/badges/sheyda-badge/sheyda-badge.component';
import { IconButtonComponent } from '@components/buttons/icon-button/icon-button.component';
import { MenuButtonComponent } from '@components/buttons/menu-button/menu-button.component';
import { CountdownReleaseComponent } from '@components/countdown/countdown-release/countdown-release.component';
import { CopyrightDialogComponent } from '@components/dialogs/copyright-dialog/copyright-dialog.component';
import { ImageGeneratorComponent } from '@components/image-generator/image-generator.component';
import { LoadingSpinnerComponent } from '@components/loading/loading-spinner/loading-spinner.component';
import { DurationPipe } from '@pipes/duration.pipe';
import {
  Episode,
  EpisodeAccessType,
  EpisodeReleaseStatus,
  Maybe,
  ProgramWithSeasons,
  Season,
} from '@shared/graphql/api.generated';
import { seasonEpisodesSP } from '@shared/helper/responsive-sizes';
import { ProgramSeoService } from '@shared/seo/program.seo.service';
import { EpisodeService } from '@shared/services/episode.service';
import { GeneralService } from '@shared/services/general.service';
import { ProgramService } from '@shared/services/program.service';

@Component({
  selector: 'app-product-season',
  imports: [
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    ImageGeneratorComponent,
    DurationPipe,
    MenuButtonComponent,
    IconButtonComponent,
    LoadingSpinnerComponent,
    CountdownReleaseComponent,
    SheydaBadgeComponent,
  ],
  providers: [ProgramService, ProgramSeoService],
  templateUrl: './product-season.component.html',
  styleUrls: ['./product-season.component.scss'],
})
export class ProductSeasonComponent {
  ProgramData = input.required<ProgramWithSeasons>();
  Episode = input<Episode>();
  ProgramHasCopyright = input<boolean>();
  SeasonEpisodes = model<Episode[]>([]);
  selectedSeasonTitle = signal<string>('');
  loading = signal(true);
  episodeReleaseStatus = EpisodeReleaseStatus;
  accessType = EpisodeAccessType;
  episodeSizes = seasonEpisodesSP;

  private generalService = inject(GeneralService);
  private programService = inject(ProgramService);
  private episodeService = inject(EpisodeService);
  private programSeoService = inject(ProgramSeoService);
  private dialog = inject(MatDialog);

  ngOnChanges() {
    if (this.Episode()) {
      this.getSeasonDetails(this.Episode()?.seasonID!);
      const episodeSeason = this.ProgramData().seasons.find(
        (item) => item?.id === this.Episode()!.seasonID,
      )!;
      this.selectedSeasonTitle.set(episodeSeason.title);
    } else {
      if (this.SeasonEpisodes().length) {
        this.loading.set(false);
        if (this.Episode()) {
          const episodeSeason = this.ProgramData().seasons.find(
            (item) => item?.id === this.Episode()!.seasonID,
          )!;
          this.selectedSeasonTitle.set(episodeSeason.title);
        } else {
          this.selectedSeasonTitle.set(this.ProgramData().seasons[0]?.title!);
        }
      }
    }
  }

  handleChangeSeason(item: Maybe<Season>) {
    this.selectedSeasonTitle.set(item?.title!);
    this.getSeasonDetails(item?.id!);
  }

  getSeasonDetails(seasonId: string) {
    this.loading.set(true);
    this.SeasonEpisodes.set([]);
    this.programService.getSeasonEpisodes(seasonId).subscribe({
      next: (res) => {
        this.loading.set(false);
        this.SeasonEpisodes.set(res.data);
        this.programSeoService.setEpisodeListJsonLd(this.SeasonEpisodes());
      },
    });
  }

  handlePlayEpisode(item: Episode) {
    if (this.ProgramHasCopyright()) {
      this.dialog.open(CopyrightDialogComponent);
    } else {
      if (this.episodeService.checkEpisodeDisplay(item)) {
        this.generalService.router.navigateByUrl(`/w/${item.uid}`);
      }
    }
  }
}
